export { Document } from './document'
